import React, { useEffect, lazy, Suspense } from "react"
import { Route, Routes, BrowserRouter } from "react-router-dom"
import './index.css';
import './App.css';

import NavBar from './components/NavBar';
import Footer from "./components/Footer.js"
import GoToTop from "./components/GoToTop";

// Lazy loaded pages
const BookNow = lazy(() => import("./pages/BookNow"));
const Facilities = lazy(() => import("./pages/Facilities.js"));
const Hmo = lazy(() => import("./pages/HmoPage.js"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Doctors = lazy(() => import("./pages/Doctors"));
const Home = lazy(() => import("./pages/Home"));
const PatientPortal = lazy(() => import("./pages/PatientPortal"));
const Services = lazy(() => import("./pages/Services"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Results = lazy(() => import("./pages/Results"));

export default function App() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="app">
      <BrowserRouter>
        <NavBar />
        <main>
          <Suspense fallback={<div style={{minHeight: "90vh"}} />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />}>
                <Route path=":id" element={<Services />} />
              </Route>
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/patient-portal" element={<PatientPortal />} />
              <Route path="/results" element={<Results />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/booking" element={<BookNow />} />
              <Route path="/facilities" element={<Facilities />} />
              <Route path="/hmo" element={<Hmo />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <GoToTop />
        <Footer />
      </BrowserRouter>
    </div>
  );
}